import React from 'react'
import { Grid as GridReactStyled } from 'react-styled-flexboxgrid'

import { ThemeProvider } from 'styled-components'

const theme = {
  flexboxgrid: {
    gridSize: 12,
    gutterWidth: 1.5,
    outerMargin: 0,
    mediaQuery: 'only screen',
    container: {
      sm: 46,
      md: 61,
      lg: 76,
    },
    breakpoints: {
      xs: 0,
      sm: 53.8,
      md: 61,
      lg: 67,
    },
  },
}

const Grid = ({ children }) => (
  <ThemeProvider theme={theme}>
    <GridReactStyled style={{ width: '100%' }}>{children}</GridReactStyled>
  </ThemeProvider>
)

export default Grid
